// Logo image URL
const LOGO_IMAGE_URL = "/dme-logo.png";

export const Logo = ({ size = 'default', showText = false, className = '' }) => {
  const sizes = {
    small: { height: 102 },
    default: { height: 123 },
    large: { height: 163 },
    xl: { height: 205 },
  };

  const { height } = sizes[size] || sizes.default;

  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src={LOGO_IMAGE_URL} 
        alt="DME R'US Logo" 
        style={{ height: `${height}px`, width: 'auto' }}
        className="flex-shrink-0"
      />
    </div>
  );
};

// Alternative logo variations - just uses the same image
export const LogoMark = ({ size = 77, className = '' }) => (
  <img 
    src={LOGO_IMAGE_URL} 
    alt="DME R'US Logo" 
    style={{ height: `${size}px`, width: 'auto' }}
    className={className}
  />
);

// White version for dark backgrounds - uses the same logo (it works on dark backgrounds)
export const LogoWhite = ({ size = 'default', showText = false, className = '' }) => {
  const sizes = {
    small: { height: 102 },
    default: { height: 123 },
    large: { height: 163 },
    xl: { height: 205 },
  };

  const { height } = sizes[size] || sizes.default;

  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src={LOGO_IMAGE_URL} 
        alt="DME R'US Logo" 
        style={{ height: `${height}px`, width: 'auto' }}
        className="flex-shrink-0"
      />
    </div>
  );
};

export default Logo;
